import React, { Component } from "react"
import * as erroImage from "../errorImages"
export default class HttpError extends Component {
  render() {
    var errorImage = erroImage.getImageForError(this.props.status)
    return (
      <div className="row">
        <div className="col-md-5 col-md-offset-3 card-profile">
          <div
            className="card-avatar"
            style={{
              maxWidth: 220,
              maxHeight: 220,
              borderRadius: "10%"
            }}
          >
            <img
              alt="Imagem exibida nos relatórios"
              className="img"
              src={errorImage}
            />
          </div>
          <div className="content">
            <h6 className="category text-gray">
              <strong>{this.props.message}</strong>
            </h6>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/HttpError.js